import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import TeamBlock from 'app/components/club/TeamBlock';
import styled from 'styled-components';
import {COLORS, ELEVATIONS, SIZES, LOADING_MESSAGE, LoadingIndicator} from '@fupa/fupa-uikit';
import {Helmet} from 'react-helmet-async';
import {object, string} from 'prop-types';
import {fetchClubTeams} from 'app/routes/club/ClubPageActions';
import {ClubTeamsPageReducer} from 'app/routes/club/ClubPageReducer';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';

const Wrapper = styled.div`
  margin-bottom: ${SIZES['8']};
  box-shadow: ${ELEVATIONS.Card};
  background-color: ${COLORS.white};
`;

const ClubTeamsPage = ({club, districtName, dispatchRedux}) => {
  const {restoredData} = useRestoreData('ClubTeamsPage');
  const {clubSlug} = useParams();

  const initialState = restoredData ?? {
    isFetching: false,
    items: [],
  };
  const [state, dispatch] = useReducer(ClubTeamsPageReducer, initialState);

  const loadData = () => fetchClubTeams(clubSlug, dispatchRedux)(dispatch, state);

  const {items, isFetching} = state;
  useFetchData(state, loadData, 'ClubTeamsPage');

  let descriptionSuffix = items.length === 1 ? ' ➤ 🎽 1 Team' : ` ➤ 🎽 ${items.length} Teams`;
  items.slice(0, 3).map(item => {
    descriptionSuffix += ` ➤ 🏆 ${item.competition.name}`;
  });
  const meta = [
    {
      name: 'description',
      content: `Alle Infos, Statistiken und Team-Kader zu ${club.name} ➤ ${club.middleName} ➤ ${club.shortName} ➤ ${districtName}${descriptionSuffix}`,
    },
    {
      name: 'robots',
      content: 'index',
    },
  ];

  let content = null;
  if (isFetching) {
    content = <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor />;
  } else if (items.length) {
    content = items.map(team => (
      <Wrapper key={team.slug}>
        <TeamBlock team={team} />
      </Wrapper>
    ));
  }

  return (
    <ContentAdDesktop superbannerOnly top='7.125rem' bgColor>
      <Helmet title={'Teams - '} meta={meta} />
      {content}
    </ContentAdDesktop>
  );
};

ClubTeamsPage.propTypes = {
  club: object,
  districtName: string,
};

export default ClubTeamsPage;
